import { FC, useMemo } from 'react';
import styled from '@emotion/styled';
import P1 from '@base/P1/P1';
import H6 from '@base/H6/H6';
import ChevronRight from '@icon/ChevronRight';
import Image from '@base/Image';
import { Spacings, breakpoints, mediaQuery } from '@styles/index';
import { AnyArgVoidReturnFunction } from 'types/utils';
import P2 from '@base/P2/P2';
import { PAYMENT_TYPES } from './constants';

const PaymentMethod = styled.div<{ $mwebCheckoutV2: Boolean }>`
  padding: ${Spacings.SPACING_3B};
  margin-bottom: ${Spacings.SPACING_2B};
  cursor: pointer;
  display: flex;
  align-items: center;
  @media only screen and (max-width: ${breakpoints.tablet}) {
    padding: 8px 0;
    margin: 0px;
    :not(:last-of-type) {
      border-bottom: ${({ $mwebCheckoutV2 }) =>
        !$mwebCheckoutV2 && '1px solid var(--color-divider)'};
    }
  }
`;

const Icon = styled.div<{ isSelected: boolean; $mwebCheckoutV2: Boolean }>`
  margin-right: ${Spacings.SPACING_2B};
  ${mediaQuery.uptoMobile} {
    padding-top: ${({ $mwebCheckoutV2 }) => ($mwebCheckoutV2 ? '8px' : '0px')};
    margin-right: ${({ $mwebCheckoutV2 }) =>
      $mwebCheckoutV2 ? '16px' : '8px'};
  }
`;

const Right = styled(ChevronRight)`
  display: none;
  @media only screen and (max-width: ${breakpoints.tablet}) {
    display: block;
  }
`;

const SelectedText = styled(H6)`
  @media only screen and (max-width: ${breakpoints.tablet}) {
    flex: 1;
  }
`;

const Text = styled(P1)`
  @media only screen and (max-width: ${breakpoints.tablet}) {
    flex: 1;
  }
`;

const LabelWrapper = styled.div`
  display: flex;
  flex: 1;
  flex-direction: column;
`;

const Desciption = styled(P2)`
  color: var(--color-text-secondary);
`;

interface IPaymentMethodItemProps {
  type: number;
  label: string;
  onClick: AnyArgVoidReturnFunction;
  isSelected: boolean;
  imageSrc: String;
  mwebCheckoutV2?: Boolean;
  description?: string;
}

const PaymentMethodItem: FC<IPaymentMethodItemProps> = ({
  type,
  label,
  isSelected,
  onClick,
  imageSrc,
  mwebCheckoutV2 = false,
  description = ''
}) => {
  const handleOnClick = () => {
    if (onClick) {
      onClick(type, label);
    }
  };

  const imgUrl = useMemo(() => {
    if (type === PAYMENT_TYPES.PAY_IN_PARTS) return 'payments/pay_in_parts.png';
    if (type === PAYMENT_TYPES.CARD) return 'payments/card.png';
    if (type === PAYMENT_TYPES.NET_BANKING) return 'payments/net_banking.png';
    if (type === PAYMENT_TYPES.UPI) return 'payments/upi.png';
    if (type === PAYMENT_TYPES.WALLETS) return 'payments/wallet.png';
    if (type === PAYMENT_TYPES.EMI) return 'payments/emi-options.png';
    if (type === PAYMENT_TYPES.CASH) return 'payments/cash.png';
    if (type === PAYMENT_TYPES.LOAN) return 'payments/loan.png';
  }, [type]);

  return (
    <PaymentMethod
      data-id={type}
      onClick={handleOnClick}
      $mwebCheckoutV2={mwebCheckoutV2}
    >
      <Icon isSelected={isSelected} $mwebCheckoutV2={mwebCheckoutV2}>
        <Image
          src={mwebCheckoutV2 ? imageSrc : imgUrl}
          width={32}
          height={32}
          alt="-"
        />
      </Icon>
      <LabelWrapper>
        {isSelected ? (
          <SelectedText>{label}</SelectedText>
        ) : (
          <Text>{label}</Text>
        )}
        {mwebCheckoutV2 && description ? (
          <>
            {label !== 'UPI' ? <Desciption>{description}</Desciption> : <></>}
          </>
        ) : null}
      </LabelWrapper>

      <Right size="24px" color="var(--color-i-black)" />
    </PaymentMethod>
  );
};
export default PaymentMethodItem;
